import React from "react";
import "./App.css";
import Dashboard from "Views/dashboard";
import Safety from "Views/safety";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "Views/Auth/LoginFlow/Login";
import VerifyOtp from "Views/Auth/LoginFlow/Verify-otp";
import CreateProject from "Views/project-creation/CreateProject/Index";
import ProjectList from "Views/project-creation/ProjectList/ProjectList";
import AddIssues from "Views/KeyIssue/AddIssue";
import ProjectHeader from "layouts/ProjectHeader";
import ProjectLanding from "view/projectLanding";
import ActionTracker from "view/actionTracker";
import PhysicalProgress from "view/dpr/physical-progress";
import AddDPR from "view/dpr/physical-progress/AddDPR";
import ProjectLayOut from "layouts/ProjectLayOut";
import WorkSpaceSetup from "view/WorkSpaceSetup";
import ViewDPR from "view/dpr/physical-progress/ViewDPR";
import MonthlyPlan from "view/dpr/monthly-plan";
import Comments from "view/actionTracker/Comments";
import IssueList from "Views/KeyIssue/IssueList";
import AddMonthlyPlan from "view/dpr/monthly-plan/AddPlan";
import ViewMonthlyPlan from "view/dpr/monthly-plan/ViewPlan";
import MyWorkDashboard from "view/MyWork/myWorkList";
import Schedule from "view/schedule";
// import Milestone from "view/dpr/milestone";
import UserList from "view/user-management";
import UserLayOut from "layouts/userlayout";
import WorkDetail from "view/MyWork/WorkDetail";
import AllWorkFlowList from "view/settings/workflow/AllWorkFlowList";
import AddWorkflow from "view/settings/workflow/AddWorkflow";
import AddWorkflowConfiguration from "view/settings/workflow/AddWorkflowConfiguration";
import ImplementationSchedule from "view/baselineSchedule/ImplementationSchedule";
import MasterScheduleDevelopment from "view/baselineSchedule/MasterScheduleDevelopment";
import ProjectBaselineSchedule from "view/baselineSchedule/ProjectBaselineSchedule";
import ProjectBaselineScheduleUpdate from "view/baselineSchedule/ProjectBaselineScheduleUpdate";
import ProjectRecoverySchedule from "view/baselineSchedule/ProjectRecoverySchedule";
import ProjectReBaselineSchedule from "view/baselineSchedule/ProjectReBaselineSchedule";
import ProjectScheduleUpdate from "view/baselineSchedule/ProjectScheduleUpdate";
import Risk from "view/risk";
import ComplianceTrackerList from "view/complianceTracker/ComplianceTrackerList";
import CostManagementDashboard from "view/dashboard/costManagement";
import ScheduleDashboard from "view/dashboard/schedule";
import AuthCallback from "AuthCallback";
import EngineeringDashboard from "view/dashboard/engineering";
import PortfolioLayout from "layouts/PortfolioLayout";
import Portfolio from "Views/portfolio/Portfolio";
import RoleList from "view/user-management/roles";
import RiskData from "view/settings/masterdata/risk";
import WorkFlowData from "view/settings/masterdata/workflow";
import ActionTrackerData from "view/settings/masterdata/action-tracker";
import ComplianceData from "view/settings/masterdata/compliance";
import EngineeringTracker from "view/engineeringTracker";
import SitcList from "view/procurement/sitc/SItcList";
import DPItemsList from "view/procurement/DpItems/DPItemsList";
import ApprovalTracker from "view/approvalTracker";
import RiskDashboard from "view/dashboard/risk";
import ProcurementList from "view/procurement";
import NcrLogTracker from "view/ncrlogtracker";
import ProcurementDashboard from "view/dashboard/procurement";
import ContractManagementDashboard from "view/dashboard/contractManagement";
import CostTracker from "view/costTracker";
import ClaimTracker from "view/claimTracker";
import EditWorkflow from "view/settings/workflow/EditWorkflow";
import WorkflowFlowView from "view/settings/workflow/WorkflowFlowView";
import DMSExplorer from "view/dms/DMSExplorer";
import WeeklyActualUpdate from "view/costTracker/WeeklyActualUpdate";
import IncidentTracker from "view/hseTracker";
import HSETracker from "view/hseStaticsTracker";
import ViewScheduleData from "view/baselineSchedule/ViewSchedule";
import MilestoneData from "view/milestone";
import HseData from "view/settings/masterdata/hse";

import ChangeTracker from "view/changeTracker";
import PermissionList from "view/permission/PermissionList";
import Capex from "view/baselineSchedule/Capex";
import HSEDashboard from "view/dashboard/hse";
import BusinessSummary from "view/projectLanding/BusinessSummary";
import DesignEngineeringData from "view/settings/masterdata/design-engineering";
import ProcurementData from "view/settings/masterdata/procurement";
import StatutoryApprovalData from "view/settings/masterdata/statutory-approval";
import CustomerDashboard from "view/dashboard/customer";
import RequireAuth from "components/RequireAuth";
import EHSFindingTracker from "view/ehsFindingTracker";
import EHSFindingData from "view/settings/masterdata/ehs-finding";
import LegalTracker from "view/legalTracker";
import ProjectSettings from "view/settings/projectSettings";
import LegalComplianceData from "view/settings/masterdata/legal-compliance";
import InitiateWorkflow from "view/initiateWorkflow";
import WorkflowHistory from "view/initiateWorkflow/WorkflowHistory";
import InvoiceTracker from "view/invoiceTracker";
import AssetManagement from "view/dashboard/assetManagement";
import LeaseDashboard from "view/dashboard/lease";
import IrrViewTracker from "view/amTracker/irrView";
import RevenueLeasingTracker from "view/amTracker/revenue&leasing";
import CamTracker from "view/amTracker/cam";
import InsuracneTracker from "view/amTracker/insurance";
import OperatingCostTracker from "view/amTracker/operatingCost";
import WarehousingRevenueLeasing from "view/settings/masterdata/warehousingRevenue";
import CommercialRevenueLeasing from "view/settings/masterdata/commercialRevenue";
import RailRevenueLeasing from "view/settings/masterdata/railRevenue";
import InsuranceRevenueLeasing from "view/settings/masterdata/insurance";
import LeadsTracker from "view/leads";
import DealsTracker from "view/deals";
import LeadsData from "view/settings/masterdata/leads";
import OperatingCostData from "view/settings/masterdata/operating-cost";
import SafexpressDashboard from "view/dashboard/customer/SafexpressDashboard";
import CustomerDependenciesList from "view/settings/customerDependencies";
import ErpData from "view/erpData";
import FinancialBGList from "view/financialBGTracker";
import FinancialBGData from "view/settings/masterdata/financial-bg";
import InvoiceData from "view/settings/masterdata/invoice";
import ClaimData from "view/settings/masterdata/claim";
import ChangeData from "view/settings/masterdata/change";
import NCRLogData from "view/settings/masterdata/ncr-log";
import FinancialDashboard from "view/dashboard/financial";

function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/work" element={<WorkSpaceSetup />} />
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route path="/login" element={<Login />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route path="/resend-otp" />
      <Route path="/addproject" element={<CreateProject />} />
      <Route path="my-work-dashboard/details" element={<WorkDetail />}></Route>


      <Route
        element={
          <RequireAuth>
            <ProjectHeader />
          </RequireAuth>
        }
      >
        <Route path="/project-list" element={<ProjectList />} />
        <Route path="my-work-dashboard" element={<MyWorkDashboard />}></Route>

        {/* Global User */}
        <Route path="user-management/users" element={<UserList />} />
        <Route path="action-tracker" element={<ActionTracker />} />

        {/* AM Tracker */}
        <Route path="irr-view-tracker" element={<IrrViewTracker />} />
        <Route path="revenue-leasing-tracker" element={<RevenueLeasingTracker />} />
        <Route path="cam-tracker" element={<CamTracker />} />
        <Route path="insurance-tracker" element={<InsuracneTracker />} />
        <Route path="operatingCost-tracker" element={<OperatingCostTracker />} />

      </Route>

      <Route
        path="projects/:projectId/"
        element={
          <RequireAuth>
            <ProjectLayOut />
          </RequireAuth>
        }
      >
        <Route index element={<ProjectLanding />} />
        <Route path="business-summary" element={<BusinessSummary />} />
        <Route path="action-tracker" element={<ActionTracker />} />
        <Route path="action-tracker/comments" element={<Comments />} />
        <Route path="engineering-tracker" element={<EngineeringTracker />} />
        <Route path="approval-tracker" element={<ApprovalTracker />} />

        <Route path="dms" element={<DMSExplorer />} />

        {/* Dashboards */}
        <Route
          path="dashboard/cost-management"
          element={<CostManagementDashboard />}
        />
        <Route path="dashboard/schedule" element={<ScheduleDashboard />} />
        <Route
          path="dashboard/engineering"
          element={<EngineeringDashboard />}
        />
        <Route
          path="dashboard/risk"
          element={<RiskDashboard />}
        />
        <Route
          path="dashboard/procurement"
          element={<ProcurementDashboard />}
        />
        <Route
          path="dashboard/contract-management"
          element={<ContractManagementDashboard />}
        />
        <Route
          path="dashboard/hse"
          element={<HSEDashboard />}
        />
        <Route
          path="dashboard/lease"
          element={<LeaseDashboard />}
        />
        <Route
          path="dashboard/customer"
          element={<CustomerDashboard />}
        />
        <Route
          path="dashboard/safexpressdashboard"
          element={<SafexpressDashboard />}
        />

         <Route
          path="dashboard/financial"
          element={<FinancialDashboard />}
        />

        <Route path="safety" element={<Safety />} />
        <Route path="issue-list" element={<IssueList />} />
        <Route path="dpr/physical-progress" element={<PhysicalProgress />} />
        <Route path="dpr/physical-progress/add-dpr" element={<AddDPR />} />
        <Route path="dpr/physical-progress/view-dpr" element={<ViewDPR />} />
        <Route path="dpr/monthly-plan" element={<MonthlyPlan />} />
        <Route path="dpr/monthly-plan/add-plan" element={<AddMonthlyPlan />} />
        <Route
          path="dpr/monthly-plan/view-plan"
          element={<ViewMonthlyPlan />}
        />

        <Route path="risk" element={<Risk />} />

        <Route path="schedule" element={<Schedule />} />
        {/* <Route path="dpr/milestone" element={<Milestone />} /> */}
        <Route path="settings/workflow" element={<AllWorkFlowList />} />
        <Route path="settings/workflow/addworkflow" element={<AddWorkflowConfiguration />} />
        <Route path="settings/workflow/:id/edit" element={<EditWorkflow />} />
        <Route path="settings/workflow/:id/view" element={<WorkflowFlowView />} />
        <Route path="settings/project-settings" element={<ProjectSettings />} />
        <Route path="settings/customer-dependencies" element={<CustomerDependenciesList />} />
        {/* Baseline schedule */}
        <Route
          path="implementation-schedule"
          element={<ImplementationSchedule />}
        />
        <Route
          path="master-development-schedule"
          element={<MasterScheduleDevelopment />}
        />
        <Route
          path="project-baseline-schedule"
          element={<ProjectBaselineSchedule />}
        />
        <Route
          path="project-baseline-schedule-update"
          element={<ProjectBaselineScheduleUpdate />}
        />
        <Route
          path="project-recovery-schedule"
          element={<ProjectRecoverySchedule />}
        />
        <Route
          path="project-rebaseline-schedule"
          element={<ProjectReBaselineSchedule />}
        />
        <Route
          path="project-schedule-update"
          element={<ProjectScheduleUpdate />}
        />
        <Route
          path="capex"
          element={<Capex />}
        />
        <Route
          path="schedule-view"
          element={<ViewScheduleData />}
        />
        <Route
          path="milestone"
          element={<MilestoneData />}
        />

        {/* compliance tracker */}
        <Route path="compliance-tracker" element={<ComplianceTrackerList />} />

        {/* Project User */}
        <Route path="user-management/users" element={<UserList />} />
        <Route path="user-management/roles" element={<RoleList />} />

        <Route path="settings/masterdata/risk" element={<RiskData />} />
        <Route path="settings/masterdata/workflow" element={<WorkFlowData />} />
        <Route path="settings/masterdata/action-tracker" element={<ActionTrackerData />} />
        <Route path="settings/masterdata/compliance" element={<ComplianceData />} />
        <Route path="settings/masterdata/design-engineering" element={<DesignEngineeringData />} />
        <Route path="settings/masterdata/procurement" element={<ProcurementData />} />
        <Route path="settings/masterdata/statutory-approval" element={<StatutoryApprovalData />} />
        <Route path="settings/masterdata/ehs-finding" element={<EHSFindingData />} />
        <Route path="settings/masterdata/hse" element={<HseData />} />
        <Route path="settings/masterdata/legal-compliance" element={<LegalComplianceData />} />
        <Route path="settings/masterdata/warehousing" element={<WarehousingRevenueLeasing />} />
        <Route path="settings/masterdata/rail" element={<RailRevenueLeasing />} />
        <Route path="settings/masterdata/commercial" element={<CommercialRevenueLeasing />} />
        <Route path="settings/masterdata/insurance" element={<InsuranceRevenueLeasing />} />

        <Route path="settings/masterdata/leads" element={<LeadsData />} />
        <Route path="settings/masterdata/operating-cost" element={<OperatingCostData />} />

        <Route path="settings/masterdata/financial-bg" element={<FinancialBGData />} />
        <Route path="settings/masterdata/invoice" element={<InvoiceData />} />
        <Route path="settings/masterdata/claim" element={<ClaimData />} />
        <Route path="settings/masterdata/change" element={<ChangeData />} />
        <Route path="settings/masterdata/ncr-log" element={<NCRLogData />} />

        {/* procurement */}
        {/* <Route path="procurement-sitc" element={<SitcList />} />

        <Route path="procurement-dp-items" element={<DPItemsList />} /> */}
        <Route path="procurement" element={<ProcurementList />} />
        {/* <Route path="procurement-dp-items" element={<DPItemsList />} /> */}

        {/* NCR Log Tracker */}
        <Route path="ncr-log-tracker" element={<NcrLogTracker />} />
        <Route path="cost-tracker" element={<CostTracker />} />
        <Route path="cost-tracker-update" element={<WeeklyActualUpdate />} />


        {/* clain tracker */}
        <Route path="claim-tracker" element={<ClaimTracker />} />
        <Route path="change-tracker" element={<ChangeTracker />} />

        {/* Invoice tracker */}
        <Route path="invoice-tracker" element={<InvoiceTracker />} />
        <Route path="erp-data" element={<ErpData />} />

        <Route path="incident-tracker" element={<IncidentTracker />} />
        <Route path="hse-tracker" element={<HSETracker />} />
        <Route path="ehs-finding-tracker" element={<EHSFindingTracker />} />
        <Route path="legal-tracker" element={<LegalTracker />} />

        {/* roles and permission */}
        <Route path="assign-permission" element={<PermissionList />} />

        {/* initiate workflow */}
        <Route path="initiate-workflow" element={<InitiateWorkflow />} />
        <Route path="initiate-workflow/:id/:entityName/workflow-history" element={<WorkflowHistory />} />
        {/* Lease Tracker */}
        <Route path="leads-tracker" element={<LeadsTracker />} />
        <Route path="deals-tracker" element={<DealsTracker />} />

        
        {/* Financial BG Tracker */}
        <Route path="financial-bg-tracker" element={<FinancialBGList />} />
      </Route>
      {/* Project User */}
      <Route path="user-management/users" element={<UserList />} />
      <Route path="user-management/roles" element={<RoleList />} />

      <Route
        element={
          <RequireAuth>
            <PortfolioLayout />
          </RequireAuth>
        }
      >
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="action-tracker" element={<ActionTracker />} />
        <Route path="asset-management" element={<AssetManagement />} />
      </Route>

    </Routes>
  );
}

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
